<template>
  <div
    v-if="
      neopassDatas[constants.PAGE_NEOPASS_FORM_PARCOURS] &&
      neopassDatas[constants.PAGE_NEOPASS_FORM_PARCOURS].length > 0
    "
  >
    <h3 class="xl:my-15">Stages</h3>

    <div class="grid grid-cols-2 gap-5 justify-between">
      <div class="col-span-2 lg:col-span-1 flex flex-col items-center w-full">
        <h5 class="text-indigo-600 text-xl font-semibold my-8">
          Durées de stage
        </h5>
        <div
          class="border-dashed border-gray-600 rounded-2xl border-2 p-5 w-full md:w-max"
        >
          <div
            class="border-dashed border-gray-600 border-b-2 pb-5 flex space-x-3 items-center"
          >
            <div class="border-2 rounded-full border-indigo-600 p-1.5">
              <icon class="text-indigo-600 h-4 w-4" name="collapse" />
            </div>
            <div class="text-2xl text-indigo-600">
              {{ parseInt(stageDurationInformations.avg) }}h
            </div>
            <div>Durée moyenne des stages</div>
          </div>
          <div
            class="border-dashed border-gray-600 border-b-2 py-5 flex space-x-3 items-center"
          >
            <div class="border-2 rounded-full border-pink-600 p-1.5">
              <icon class="text-pink-600 h-4 w-4" name="arrow-up" />
            </div>
            <div class="text-2xl text-pink-600">
              {{ stageDurationInformations.max }}h
            </div>
            <div>Durée du stage le plus long</div>
          </div>
          <div class="pt-5 flex space-x-3 items-center">
            <div class="border-2 rounded-full border-pink-600 p-1.5">
              <icon class="text-pink-600 h-4 w-4" name="arrow-down" />
            </div>
            <div class="text-2xl text-pink-600">
              {{ stageDurationInformations.min }}h
            </div>
            <div>Durée du stage le plus court</div>
          </div>
        </div>
      </div>
      <div class="col-span-2 lg:col-span-1">
        <doughnut
          id-chart="typeStage"
          title="Types de stages"
          :labels="typesStage.longLabels"
          :values="typesStage.datas"
          thickness="70"
          :colors="[color('pink'), color('indigo')]"
          position-legend="bottom"
          height="400"
          width="400"
        />
      </div>
      <div class="col-span-2 md:col-span-1">
        <doughnut
          id-chart="environnementStage"
          title="Environnement de stage"
          :labels="environnementsStage.longLabels"
          :values="environnementsStage.datas"
          thickness="70"
          :colors="[color('pink'), color('indigo')]"
          position-legend="bottom"
          height="400"
          width="400"
        />
      </div>
      <div class="col-span-2 md:col-span-1">
        <doughnut
          id-chart="caracteristiqueStage"
          title="Caractéristiques du stage"
          :labels="caracteristiquesStage.longLabels"
          :values="caracteristiquesStage.datas"
          thickness="70"
          :colors="[color('pink'), color('indigo')]"
          position-legend="bottom"
          height="400"
          width="400"
        />
      </div>
    </div>

    <h3 class="xl:my-15">Formations continues</h3>
    <div class="grid grid-cols-2 space-5 justify-center items-center">
      <div class="col-span-full flex flex-col items-center">
        <div class="w-full">
          <bar
            id-chart="certifications"
            title="Certifications obtenues"
            orientation="vertical"
            :labels="certifications.shortLabels"
            :values="certifications.datas"
            thickness="10"
            height="400"
            width="400"
            :stacked="false"
          />
        </div>
        <div class="self-start ml-5">
          <p
            v-for="(lib, n) in certifications.longLabels"
            :key="n"
            class="text-2sm text-gray-600"
          >
            {{ lib }}
          </p>
        </div>
      </div>

      <div class="col-span-2 lg:col-span-1 flex flex-col items-center">
        <h5 class="text-indigo-600 text-xl font-semibold my-8">
          Durées des formations
        </h5>
        <div
          class="border-dashed border-gray-600 rounded-2xl border-2 p-5 w-full md:w-max"
        >
          <div
            class="border-dashed border-gray-600 border-b-2 pb-5 flex space-x-3 items-center"
          >
            <div class="border-2 rounded-full border-indigo-600 p-1.5">
              <icon class="text-indigo-600 h-4 w-4" name="collapse" />
            </div>
            <div class="text-2xl text-indigo-600">
              {{ parseInt(formationDurationInformations.avg) }}h
            </div>
            <div>Durée moyenne des formations</div>
          </div>
          <div
            class="border-dashed border-gray-600 border-b-2 py-5 flex space-x-3 items-center"
          >
            <div class="border-2 rounded-full border-pink-600 p-1.5">
              <icon class="text-pink-600 h-4 w-4" name="arrow-up" />
            </div>
            <div class="text-2xl text-pink-600">
              {{ formationDurationInformations.max }}h
            </div>
            <div>Durée de la formation la plus longue</div>
          </div>
          <div class="pt-5 flex space-x-3 items-center">
            <div class="border-2 rounded-full border-pink-600 p-1.5">
              <icon class="text-pink-600 h-4 w-4" name="arrow-down" />
            </div>
            <div class="text-2xl text-pink-600">
              {{ formationDurationInformations.min }}h
            </div>
            <div>Durée de la formation la plus courte</div>
          </div>
        </div>
      </div>
      <div class="col-span-2 lg:col-span-1">
        <doughnut
          id-chart="typeFormation"
          title="Types de formations"
          :labels="typesFormation.longLabels"
          :values="typesFormation.datas"
          thickness="70"
          :colors="[color('pink'), color('indigo')]"
          position-legend="bottom"
          height="400"
          width="400"
        />
      </div>
    </div>
  </div>
  <div v-else class="text-center mt-1/10 text-gray-600">
    Aucune donnée à afficher.
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Icon from '../../../components/Icon';
import ActionButton from '../../../components/ActionButton';
import Doughnut from '../../../components/Charts/Doughnut';
import Bar from '../../../components/Charts/Bar';

import Constants from './../../../constants';

export default {
  components: {
    Icon,
    ActionButton,
    Doughnut,
    Bar,
  },

  name: 'StageEtFormations',

  data() {
    return {
      constants: Constants,
    };
  },
  mounted() {
    //
  },
  methods: {
    ...mapMutations({
      //
    }),
    color(c) {
      if (c == 'indigo') {
        return '#3A18D1';
      } else if (c == 'pink') {
        return '#FF1C80';
      } else if (c == 'twelveColors') {
        return [
          '#3211C2',
          '#7B6AFF',
          '#DFE0F2',
          '#FF1C80',
          '#21B8C8',
          '#FF3900',
          '#ABD952',
          '#7BC5F9',
          '#FFA466',
          '#F7CD55',
          '#CE5AE3',
          '#F9A1D4',
        ];
      } else if (c == 'elevenColors') {
        return [
          '#3211C2',
          '#7B6AFF',
          '#DFE0F2',
          '#FF1C80',
          '#21B8C8',
          '#FF3900',
          '#ABD952',
          '#7BC5F9',
          '#FFA466',
          '#F7CD55',
          '#CE5AE3',
        ];
      } else if (c == 'tenColors') {
        return [
          '#3211C2',
          '#7B6AFF',
          '#DFE0F2',
          '#FF1C80',
          '#21B8C8',
          '#FF3900',
          '#ABD952',
          '#7BC5F9',
          '#FFA466',
          '#F7CD55',
        ];
      } else if (c == 'nineColors') {
        return [
          '#3211C2',
          '#7B6AFF',
          '#DFE0F2',
          '#FF1C80',
          '#21B8C8',
          '#FF3900',
          '#ABD952',
          '#7BC5F9',
          '#FFA466',
        ];
      } else if (c == 'eightColors') {
        return [
          '#3211C2',
          '#7B6AFF',
          '#DFE0F2',
          '#FF1C80',
          '#21B8C8',
          '#FF3900',
          '#ABD952',
          '#7BC5F9',
        ];
      }
    },
  },
  computed: {
    ...mapGetters({
      neopassDatas: 'cartographiesCollectives/neopassDatas',
    }),

    datas: function () {
      return this.neopassDatas[Constants.PAGE_NEOPASS_FORM_PARCOURS];
    },

    stageDurationInformations: function () {
      let allDurations = this.datas
        .reduce(
          (acc, data) => [
            ...acc,
            ...data.parcours
              .filter((parcours) => parcours.type === 'Stage')
              .map((parcours) =>
                parcours.value.duree_stage && !isNaN(parcours.value.duree_stage)
                  ? parcours.value.duree_stage
                  : 0
              ),
          ],
          []
        )
        .filter((duration) => duration != 0)
        .sort((a, b) => a - b);

      if (allDurations.length === 0) {
        return {
          avg: 0,
          max: 0,
          min: 0,
        };
      }

      let infos = {
        avg:
          allDurations.reduce(
            (acc, duration) =>
              acc + (duration && !isNaN(duration) ? parseInt(duration) : 0),
            0
          ) / allDurations.length,
        max: allDurations[allDurations.length - 1],
        min: allDurations[0],
      };

      return infos;
    },

    typesStage: function () {
      const listTypesStage = this.neopassDatas[
        Constants.PAGE_NEOPASS_FORM_PARCOURS
      ].reduce(
        (acc, data) => [
          ...acc,
          ...data.parcours
            .filter(
              (parcours) =>
                parcours.type === 'Stage' && parcours?.value?.type_stage
            )
            .map((parcours) => parcours.value.type_stage),
        ],
        []
      );

      const count = listTypesStage.reduce((acc, curr) => {
        if (curr in acc) {
          acc[curr]++;
        } else {
          acc[curr] = 1;
        }
        return acc;
      }, {});

      const labels = Object.keys(count);
      const datas = Object.values(count);

      return {
        longLabels: labels,
        datas: datas,
      };
    },

    environnementsStage: function () {
      const listEnvironnementStage = this.neopassDatas[
        Constants.PAGE_NEOPASS_FORM_PARCOURS
      ].reduce(
        (acc, data) => [
          ...acc,
          ...data.parcours
            .filter(
              (parcours) =>
                parcours.type === 'Stage' && parcours.value.milieu_stage
            )
            .map((parcours) => parcours.value.milieu_stage),
        ],
        []
      );

      const count = listEnvironnementStage.reduce((acc, curr) => {
        if (curr in acc) {
          acc[curr]++;
        } else {
          acc[curr] = 1;
        }
        return acc;
      }, {});

      const labels = Object.keys(count);
      const datas = Object.values(count);

      return {
        longLabels: labels,
        datas: datas,
      };
    },

    caracteristiquesStage: function () {
      const listCaracteristiquesStage = this.neopassDatas[
        Constants.PAGE_NEOPASS_FORM_PARCOURS
      ].reduce(
        (acc, data) => [
          ...acc,
          ...data.parcours
            .filter(
              (parcours) =>
                parcours.type === 'Stage' &&
                parcours.value.caracteristiques_stage
            )
            .map((parcours) => parcours.value.caracteristiques_stage),
        ],
        []
      );

      const count = listCaracteristiquesStage.reduce((acc, curr) => {
        if (curr in acc) {
          acc[curr]++;
        } else {
          acc[curr] = 1;
        }
        return acc;
      }, {});

      const labels = Object.keys(count);
      const datas = Object.values(count);

      return {
        longLabels: labels,
        datas: datas,
      };
    },

    formationDurationInformations: function () {
      let allDurations = this.datas
        .reduce(
          (acc, data) => [
            ...acc,
            ...data.parcours
              .filter(
                (parcours) =>
                  parcours.type === 'Formation professionnelle continue'
              )
              .map((parcours) =>
                parcours.value.duree_formation &&
                !isNaN(parcours.value.duree_formation)
                  ? parcours.value.duree_formation
                  : 0
              ),
          ],
          []
        )
        .filter((duration) => duration != 0)
        .sort((a, b) => a - b);

      let infos = {
        avg:
          allDurations.reduce(
            (acc, duration) =>
              acc + (duration && !isNaN(duration) ? parseInt(duration) : 0),
            0
          ) / allDurations.length,
        max: allDurations[allDurations.length - 1],
        min: allDurations[0],
      };

      if (allDurations.length === 0) {
        return {
          avg: 0,
          max: 0,
          min: 0,
        };
      }

      return infos;
    },

    typesFormation: function () {
      const listTypesFormations = this.neopassDatas[
        Constants.PAGE_NEOPASS_FORM_PARCOURS
      ].reduce(
        (acc, data) => [
          ...acc,
          ...data.parcours
            .filter(
              (parcours) =>
                parcours.type === 'Formation professionnelle continue' &&
                parcours.value.type_formation_pro
            )
            .map((parcours) => parcours.value.type_formation_pro),
        ],
        []
      );

      const count = listTypesFormations.reduce((acc, curr) => {
        if (curr in acc) {
          acc[curr]++;
        } else {
          acc[curr] = 1;
        }
        return acc;
      }, {});

      const labels = Object.keys(count);
      const datas = Object.values(count);

      return {
        longLabels: labels,
        datas: datas,
      };
    },

    certifications: function () {
      let listLabels = {
        Aucune: 0,
        'Niveau 3 - CAP, BEP': 0,
        'Niveau 4 - Baccalauréat': 0,
        'Niveau 5 - DEUG, BTS, DUT, DEUST': 0,
        'Niveau 6 - Licence, licence professionnelle, BUT, Maîtrise, master 1': 0,
        "Niveau 7 - Master, diplôme d'études approfondies, diplôme d'études supérieures spécialisées, diplôme d'ingénieur": 0,
        'Niveau 8 - Doctorat, habilitation à diriger des recherches': 0,
        'CQP (CQPI)': 0,
        CQPM: 0,
        'Reconnaissance CCN': 0,
        'Reconnaissance CPNAA/CPNE': 0,
        'Certification Professionnelle': 0,
        'Diplômes Européens': 0,
        CCP: 0,
        CCF: 0,
        RSFP: 0,
        'Attestation de compétences': 0,
        'Attestation de Formation': 0,
        Autres: 0,
      };

      const shortLabels = [
        'Aucune',
        'Niveau 3',
        'Niveau 4',
        'Niveau 5',
        'Niveau 6',
        'Niveau 7',
        'Niveau 8',
        'CQP',
        'CQPM',
        'CCN',
        'CPNAA/CPNE',
        'Cert. Professionnelle',
        'Euro',
        'CCP',
        'CCF',
        'RSFP',
        'Attestation comp.',
        'Attestation form.',
        'Autres',
      ];

      const listTypesFormations = this.neopassDatas[
        Constants.PAGE_NEOPASS_FORM_PARCOURS
      ].reduce(
        (acc, data) => [
          ...acc,
          ...data.parcours
            .filter(
              (parcours) =>
                parcours.type === 'Formation professionnelle continue' &&
                parcours.value.certifications_obtenues_formation_pro
            )
            .map(
              (parcours) => parcours.value.certifications_obtenues_formation_pro
            ),
        ],
        []
      );

      const count = listTypesFormations.reduce((acc, curr) => {
        if (curr in acc) {
          acc[curr]++;
        } else {
          acc[curr] = 1;
        }
        return acc;
      }, listLabels);

      const labels = Object.keys(count);
      const datas = Object.values(count);

      return {
        shortLabels: shortLabels,
        longLabels: labels,
        datas: [
          {
            label: 'Certifications',
            data: datas,
            backgroundColor: this.color('indigo'),
          },
        ],
      };
    },
  },
};
</script>
